export default __webpack_public_path__ + "static/media/bookIcon.a52d59d9.svg";